import Phaser from 'phaser';
export default class AText extends Phaser.GameObjects.Text
{
    /**
     * @param {Phaser.Scene} scene 
     * @param {Phaser.GameObjects.Container} parent 
     */
    constructor(scene, x, y, textSize, hexColor, font, text)
    {
        let colUtils = Phaser.Display.Color;
        // let color = colUtils.ValueToColor(hexColor);

        super(scene, x, y, text, {
            fontFamily: font,
            fontSize: textSize,
            // color: colUtils.RGBToString(color.red, color.green, color.blue, color.alpha)
        });

        this.tint = this._tint = hexColor;
        this.constrainedWidth = -1;
    }

    setShadow(x, y, color, blurAmount = 0)
    {
        let colUtils = Phaser.Display.Color;
        let pCol = colUtils.ValueToColor(color);
        let newColor = colUtils.RGBToString(pCol.red, pCol.green, pCol.blue);

        super.setPadding(x + blurAmount, y + blurAmount);
        super.setShadow(x, y, newColor, blurAmount);
    }

    constrainWidth(width)
    {
        this.constrainedWidth = width;
        let num = 0;
        while(this.width > this.constrainedWidth && num < 200){
            num++;
            this.fontSize--;
            this.updateText();
        }
        this.text = this.text;
    }

    setColor(hex)
    {
        this.tint = hex;
    }

    get fontSize() { return Number.parseFloat(this.style.fontSize.substr(0, this.style.fontSize.length - 2)); }
    set fontSize(value) { this.style.setFontSize(value); }

    // setText()
    // {
    //     if(this.constrainWidth != -1) this.constrainWidth(this.constrainedWidth);
    //     super.setText();   
    // }

    setBold()
    {
        this.setFontStyle('bold');
    }
}